import { Component, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { DocumentMetadata, MetadataType } from 'src/app/models/documentMetadata';

@Component({
  selector: 'app-document-countries',
  templateUrl: './document-countries.component.html',
  styleUrls: ['./document-countries.component.scss']
})
export class DocumentCountriesComponent {
  @Input() territories: string[] = []
  @Input() mode: string = 'list';
  @Input() metadata?: DocumentMetadata[] = [];
  @Input() shown: boolean = false;
  @Input() title: boolean = true;
  @Input("filter") filter: string[] = [];
  limit: number = 4;

  _territories: { code: string, confidence: number }[] = [];

  constructor(
    private translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.populateConfidence();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['territories'] && !_.isEqual(changes['territories']['currentValue'], changes['territories']['previousValue']))
      || (changes['metadata'] && !_.isEqual(changes['metadata']['currentValue'], changes['metadata']['previousValue'])
        || (changes['filter'] && !_.isEqual(changes['filter']['currentValue'], changes['filter']['previousValue'])))
    ) {
      this.populateConfidence();
    }
  }

  getConfidence(country_code: string) {
    return (this.metadata?.find(datum => datum.type === MetadataType.LOCATION && datum.value === `${country_code}`)?.confidence ?? 0) * 100
  }

  populateConfidence() {
    this._territories = this.filtered().map((territory) => ({
      code: territory,
      confidence: this.getConfidence(territory)
    }))
  }

  toggle() {
    if (this.limit === 4) {
      this.limit = this.territories.length;
    } else {
      this.limit = 4;
    }
  }

  moreTooltip() {
    return this.translate.instant('UTILS.X_MORE', { x: this.territories.length - this.limit })
  }

  hasFilters(): boolean {
    return this.filter && this.filter.length > 0 ? true : false;
  }

  filtered() {
    if (!this.hasFilters())
      return this.territories;
    return this.territories.filter((t) => this.filter?.includes(t))
  }
}
